/* globals document window */

import * as referrerStorage from 'shared/utils/referrerStorage';

import setupImpressionDurationTracking from './setupImpressionDurationTracking';
import setupImpressionTracking from './setupImpressionTracking';
import setupPageviewTracking from './setupPageviewTracking';
import setupSimpleEventTracking from './setupSimpleEventTracking';

async function main() {
  if (window.top !== window.self) return;

  referrerStorage.unsetStickyReferrerIfExpired();

  const storedStickyReferrer = referrerStorage.getStickyReferrer();
  const isReferrerExternal = !(document.referrer === '' || document.referrer.includes(window.location.hostname));

  referrerStorage.setEntryPoint(window.location.href);

  if (!storedStickyReferrer || isReferrerExternal) {
    const externalReferrer = isReferrerExternal ? document.referrer : undefined;

    referrerStorage.setStickyReferrer(externalReferrer);
  }

  setupPageviewTracking();
  setupSimpleEventTracking();
  setupImpressionTracking();
  setupImpressionDurationTracking();
}

main();
